/**
 * Datos estructurados compartidos (JSON-LD).
 *
 * Auditoría de schema del 16-9-2026: Organization, WebSite y las aplicaciones
 * eran entidades sueltas, sin @id que las relacionara; no había WebSite; la
 * Organization no tenía logo; y no había BreadcrumbList en ninguna página, que
 * es el único de estos tipos con resultado enriquecido vivo en Google.
 *
 * Todas las páginas referencian la misma Organization y el mismo WebSite por @id.
 */
export const SITE = "https://whappscan.com";
export const ORG_ID = `${SITE}/#organization`;
export const WEBSITE_ID = `${SITE}/#website`;

export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": ORG_ID,
    name: "WhappScan",
    url: SITE,
    // Ruta SIN hash de contenido: un asset con hash de CRA cambia en cada build.
    logo: { "@type": "ImageObject", url: `${SITE}/logo.png`, width: 700, height: 150 },
    // Descripción y temas: la misma frase que las fichas de directorios
    // (whappscan.com-audit/kit-directorios.md), para que los motores de IA
    // reconozcan todas como la misma entidad.
    description:
      "WhappScan extracts data from invoices, receipts, delivery notes and IDs sent by WhatsApp or upload, and delivers it to Excel, CSV or your ERP via API.",
    email: "hola@whappscan.com",
    knowsAbout: [
      "Intelligent document processing",
      "Invoice data extraction",
      "OCR",
      "E-invoicing",
      "Guest registration",
      "MRZ",
    ],
    sameAs: [
      "https://www.instagram.com/whappscan/",
      "https://www.facebook.com/profile.php?id=61585612529153",
      "https://www.youtube.com/@WhappScan",
    ],
  };
}

export function websiteSchema(lang) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": WEBSITE_ID,
    name: "WhappScan",
    url: SITE,
    inLanguage: lang,
    publisher: { "@id": ORG_ID },
  };
}

/** items: [{ name, path }] — path relativo (/es/free). El primero suele ser la portada. */
export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE}${it.path}`,
    })),
  };
}

/** Aplicación gratuita de una página de herramienta. */
export function toolAppSchema({ name, url, description, lang, featureList }) {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name,
    url,
    description,
    inLanguage: lang,
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    // Sin aggregateRating a propósito: no hay reseñas reales publicadas.
    offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
    publisher: { "@id": ORG_ID },
    ...(featureList ? { featureList } : {}),
  };
}
